export function advisorFirstName(name?: string | null, email?: string | null): string {
  const raw = (name ?? "").trim() || (email ?? "").trim();
  if (!raw) return "Rådgivare";
  const local = raw.includes("@") ? raw.split("@")[0] : raw;
  const first = local.split(/[\s._-]+/).filter(Boolean)[0] ?? local;
  return first.charAt(0).toUpperCase() + first.slice(1);
}
